import { useMutation } from '@tanstack/react-query'

import { toastFactory } from '@/factories'
import { resetQueries } from '@/utils'
import { getApiErrorMessage } from '@/utils/error'

import { authAPI } from '../new-api'
import { GET_CHECKLIST_TASK_DETAILS_BASE_QUERY_KEY } from './get-checklist-task-details'
import { GET_CHECKLISTS_BASE_QUERY_KEY } from './get-checklists'

interface RequestRevisionChecklistRequest {
  checklistId: number
  revisionRequestNote: string
}

export const requestRevisionChecklist = async (data: RequestRevisionChecklistRequest) => {
  const response = await authAPI.post(`/checklist-unified/${data.checklistId}/request-revision`, {
    revisionRequestNote: data.revisionRequestNote,
  })
  return response.data
}

export const useRequestRevisionChecklist = () => {
  return useMutation({
    mutationFn: requestRevisionChecklist,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async () => {
      await resetQueries(
        [GET_CHECKLISTS_BASE_QUERY_KEY],
        [GET_CHECKLIST_TASK_DETAILS_BASE_QUERY_KEY],
      )
      toastFactory.success('Revision requested successfully')
    },
  })
}
